import script from "./board_write.vue?vue&type=script&setup=true&lang=js"
export * from "./board_write.vue?vue&type=script&setup=true&lang=js"

import "./board_write.vue?vue&type=style&index=0&id=0371d402&lang=css"

const __exports__ = script;

export default __exports__